import { Component, inject, Input, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";

@Component({
  selector: "app-banner-card",
  templateUrl: "./banner-card.component.html",
  styleUrls: ["./banner-card.component.scss"],
})
export class BannerCardComponent {
  nav = inject(NavController);
  @Input() banner:string = 'assets/images/beltur/organization.png'
  @Input() title:string = 'SalesAndInvitation'
  @Input() webSite:string = 'VisitWebsite'
  @Input() url:string = 'organization'
  @Input() content:string = 'Content'
 
  goTo(route:string) {
    this.nav.navigateForward(route);
  }
}
